<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Protégez-vous contre le Risque Cybersécurité Informatique - Cyberattaque</h2>
    <p>
      <strong>Prémunir votre activité économique</strong> des conséquences lourdes des cyberattaques pour votre entreprise est devenu primordial dans l'économie d'aujourd'hui.
    </p>
    <p>
      Les cyber-risques sont devenus la première source d'inquiétude pour les entreprises, grandes comme petites. Une cyberattaque peut paralyser votre activité, détruire votre réputation et entraîner des pertes financières considérables. L'assurance cyber-risque vous protège contre les conséquences financières, juridiques et opérationnelles d'incidents tels que le piratage de données, les ransomwares ou les interruptions d'activité.
    </p>
    <p>
      Le marché des cyberattaques est en plein essor et promet de croître encore. <strong>C'est pourquoi BROKINS vous assure à de meilleures assurances contre GENERAL HACKING, APIS, ou bien la fraude humaine CSBE et les autres risques cyber</strong>.
    </p>
    <p>
      <strong>Le broking digital</strong> : Le suivi de votre courtage et la protection de votre courtier avec une <strong>Assurance Protection Professionnelle</strong>
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Qu'est-ce que le risque numérique ou risque cyber ?</h2>
    <p>
      Le risque cyber regroupe plusieurs menaces dans le monde numérique et les obligations liées à la protection des données.
    </p>
    <p>
      Il existe plusieurs risques informatiques menaçant une entreprise : intrusions sur les systèmes, hacks, pertes de données accidentelles, logiciels malveillants, sabotages, fraudes, cyberchantage, atteintes à l'image... L'activité de l'entreprise peut ainsi être gravement compromise voire même paralysée.
    </p>
    <p><strong>Exemples :</strong></p>
    <ul>
      <li>INTRUSION</li>
      <li>DOMMAGE D'INTÉRÊTS</li>
      <li>CRISE DE RÉPUTATION</li>
      <li>FRAUDE</li>
      <li>DÉNI DE SERVICE (DDoS)</li>
      <li>CYBER RANÇON (Ransomware)</li>
      <li>CYBER ESPIONNAGE</li>
      <li>PHISHING</li>
      <li>SITE WEB COMPROMIS</li>
      <li>VER OU VIRUS INFORMATIQUE</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Les conséquences pour votre entreprise</h2>
    <p>
      Un risque numérique peut entraîner la paralysie de votre activité professionnelle
    </p>
    
    <div class="consequences-grid">
      <div class="consequence-box">
        <h3>Impacts Récurrents</h3>
        <h4>Impacts Informatiques et Comptables</h4>
        <ul>
          <li>Reconstruction de sites Web</li>
          <li>Traitement des malwares et virus</li>
          <li>Frais de notification réglementaires</li>
          <li>Frais de gestion d'alerte</li>
          <li>Frais de surveillance du crédit</li>
          <li>Frais de reconstitution de données</li>
        </ul>
      </div>
      <div class="consequence-explanation">
        <p>
          Une cyberattaque provoque l'interruption de votre infrastructure informatique et peut créer des temps d'arrêt dans l'usage de vos ordinateurs.
        </p>
      </div>
    </div>
  </div>

  <div class="content-section bg-accent">
    <h2>Une protection indispensable pour répondre aux nouvelles obligations réglementaires</h2>
    <p>
      La réglementation européenne impose l'obligation de notifier certaines violations de données personnelles auprès de la CNIL, aux personnes concernées et selon leur État Européen.
    </p>
    <p>
      En cas de non-respect de ces obligations, vous encourez une sanction administrative, pouvant aller jusqu'à 4% du chiffre d'affaires.
    </p>
    <p><strong>Qui est concerné ?</strong></p>
    <ul>
      <li>Les opérateurs de télécoms et hébergeurs</li>
      <li>Les prestataires proposant des services en ligne</li>
    </ul>
    <p>
      Depuis mai 2018, le règlement européen RGPD s'applique à tous ceux qui traitent des données personnelles. Le risque de sanctions financières va de 2% à 4% du chiffre d'affaires en cas de non-respect.
    </p>
    <p>
      En France, les OSE (opérateurs de services essentiels) sont concernés directement par la directive européenne NIS.
    </p>
  </div>

  <div class="content-section">
    <h2>Êtes-vous concerné ?</h2>
    <p><strong>Les principaux secteurs visés sont :</strong></p>
    <ul>
      <li>82% des organisations visées sont dans le secteur Finance</li>
      <li>76% Télécommunications</li>
      <li>75% L'industrie et les fabricants de cybersécurité en France en 2019</li>
      <li>57% des attaques concernent les organisations de 250 collaborateurs et plus</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Quelles garanties pour quelles protections ?</h2>
    <p>
      L'assurance <strong>Garantie Protection Risques Cyber</strong> de <strong>Brokins</strong> intervient en cas de cyber-risque en couvrant les conséquences des risques numériques.
    </p>
    <ul>
      <li>Les garanties Dommages vous assurent contre les incidents numériques qui correspondent à votre activité</li>
      <li>Les dépenses de prévention</li>
    </ul>

    <h3>Garantie dommages et frais :</h3>
    <ul>
      <li>Frais de procédures</li>
      <li>Frais de gestion de la situation accidentelle</li>
      <li>Frais de notification et prévention des clients</li>
      <li>Frais de reconstitution et restauration de données suite à malware ou intrusion</li>
      <li>Perte d'exploitation</li>
      <li>Coûts directs des rançons</li>
    </ul>

    <h3>Les garanties Responsabilité Civile vous offrent une sécurité complémentaire :</h3>
    <ul>
      <li>RC en cas de divulgation de données privées de tiers</li>
      <li>RC en cas d'infractions de propriété intellectuelle des tiers</li>
      <li>RC des infractions en ligne sur un tiers</li>
      <li>Protection réglementaire/administrative</li>
      <li>Atteinte numérique</li>
      <li>Perturbation du réseau</li>
    </ul>

    <h3>Services complémentaires :</h3>
    <ul>
      <li>Mise à disposition d'ingénieurs en cybersécurité pour détecter et évaluer une attaque</li>
      <li>Prise en charge des coûts d'experts en communication pour la gestion de crise</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>Les points forts des contrats d'assurance Protection Numérique CYBER</h2>
    <ul>
      <li><strong>COMPLET :</strong> Une garantie qui couvre tous les impacts financiers d'une cyber-attaque</li>
      <li><strong>ADAPTÉ :</strong> Une aide adaptée au management de votre entreprise</li>
      <li><strong>ACCESSIBLE :</strong> Des tarifications compétitives et des cotisations adaptées</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Que faire en cas d'incident ?</h2>
    <p>
      Un incident cyber peut avoir un impact dévastateur sur votre activité :
    </p>
    <p>
      Sans contrat d'assurance, les dommages peuvent avoir un impact financier considérable sur votre trésorerie informatique dans cette période critique.
    </p>
    <ul>
      <li>Les solutions d'assurance cyber sont accessibles sur contrats conditions</li>
      <li>Protection contre la fraude et les atteintes à l'intégrité</li>
      <li>Garanties logiciels</li>
      <li>Protection contre toutes cyber-attaques</li>
    </ul>
    <p>
      <strong>Important :</strong> De nombreux coûts d'opérations nécessitent l'intervention d'experts techniques. Le service Information des Assurances vous accompagne dans ce type de situation.
    </p>
    <p>
      Dans les consultations de prévention, BROKINS vous accompagne avec des pistes d'amélioration de votre cyber-risque. Notre équipe d'experts en cybersécurité vous guide dans le développement de votre protection et la certification avec nos solutions d'assurance.
    </p>
  </div>

  <div class="content-section">
    <h2>Bénéficiez de l'accompagnement d'experts de renommée mondiale</h2>
    <p>
      En cas d'incident, l'assureur mandate plusieurs experts internationaux qui interviennent directement auprès de votre infrastructure.
    </p>
    <p>
      L'assurance Protection Numérique fait appel aux meilleurs acteurs de l'industrie : Brokins Assurance France, Mondial Assistance, AXA Assistance, IRSA, références en matière de gestion des incidents de crise.
    </p>
    <p><strong>Services d'urgence inclus :</strong></p>
    <ul>
      <li>Accueil par société spécialisée 24/7</li>
      <li>Notification et information des autorités de régulation</li>
      <li>Assistance à la mise en place de surveillance de crédit pour les personnes concernées</li>
      <li>Communications publiques et gestion de crise</li>
      <li>Conseil en organisation et gestion de crise</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Des services de qualité pour répondre à vos besoins</h2>
    <p>
      La politique de prévention automatisée permet une surveillance de sécurité permanente pour votre protection, avec un diagnostic approfondi qui élargit la couverture de vos clients.
    </p>
    <p>
      Nos agents et équipes de protection sont constamment formés aux dernières évolutions, certaines garanties vous assurent une protection informatique optimale.
    </p>
    <p><strong>Nos expertises :</strong></p>
    <ul>
      <li>Activité de consultation</li>
      <li>Assistance juridique</li>
      <li>Expertise en surveillance publique</li>
      <li>Expertise en relations publiques</li>
    </ul>
  </div>

  <div class="content-section cta-section">
    <h2>Protégez votre entreprise des cyberattaques</h2>
    <p>Comparez les assurances cyber-risque adaptées à votre activité</p>
    <button class="btn-primary" routerLink="/devis">Obtenir un devis gratuit</button>
  </div>
</app-page-layout>
